import React from 'react';

import { ActionIcon, Tooltip } from '@mantine/core';
import { IconFilterOff } from '@tabler/icons-react';

import { ClassUsageSearchFilters } from '../../SearchFilters';

const ClearFilters = ({
  setSearchFilters,
  initialSearchFiltersValue,
  className,
}: {
  setSearchFilters: (filters: ClassUsageSearchFilters) => void;
  initialSearchFiltersValue: ClassUsageSearchFilters;
  className?: string;
}): JSX.Element => {
  const handleClearFilters = (): void => {
    setSearchFilters(initialSearchFiltersValue);
  };

  return (
    <Tooltip label='Clear filters' className={className}>
      <ActionIcon onClick={handleClearFilters}>
        <IconFilterOff />
      </ActionIcon>
    </Tooltip>
  );
};

export default ClearFilters;
